/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Weight_QuestionInputs */

const en_us2_onboarding_weight_question = /** @type {(inputs: Onboarding_Weight_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much do you weigh right now?`)
};

const pt_br2_onboarding_weight_question = /** @type {(inputs: Onboarding_Weight_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto você pesa atualmente?`)
};

const es_419_onboarding_weight_question = /** @type {(inputs: Onboarding_Weight_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto pesas actualmente?`)
};

const pt_pt2_onboarding_weight_question = /** @type {(inputs: Onboarding_Weight_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto pesas neste momento?`)
};

const fr_fr2_onboarding_weight_question = /** @type {(inputs: Onboarding_Weight_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien pèses-tu en ce moment ?`)
};

const de_de2_onboarding_weight_question = /** @type {(inputs: Onboarding_Weight_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viel wiegst du aktuell?`)
};

const it_it2_onboarding_weight_question = /** @type {(inputs: Onboarding_Weight_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto pesi adesso?`)
};

/**
* | output |
* | --- |
* | "How much do you weigh right now?" |
*
* @param {Onboarding_Weight_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_weight_question = /** @type {((inputs?: Onboarding_Weight_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Weight_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_weight_question(inputs)
	if (locale === "es-419") return es_419_onboarding_weight_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_weight_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_weight_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_weight_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_weight_question(inputs)
	return en_us2_onboarding_weight_question(inputs)
});
export { onboarding_weight_question as "onboarding.weight.question" }